import {forwardRef} from "react";
import ReactSelect from "react-select";
import {useWizard} from "../../hooks/useWizard";
import {ElementContainer} from "./ElementContainer";

export const DropdownInput = forwardRef((props, {ref}) => {
    const {formValues, setFormValues, setError} = useWizard();

    const value = formValues
        ? props?.options.find(
            (option) => option.value === formValues[props.name]
        )
        : null

    return (
        <ElementContainer {...props}>
            <div
                className={props.styles.dropdown}
            >
                <ReactSelect
                    components={{
                        IndicatorSeparator: () => null,
                    }}
                    menuPosition={'fixed'}
                    name={props.name}
                    onChange={({value}) => {
                        setFormValues({...formValues, [props.name]: value})
                        setError(false)

                        if (!props.componentStateHoldValue)
                            return props.setValue(props.name, value);

                        props.componentStateHoldValue({[props.name]: value});
                    }}
                    options={props.options}
                    ref={ref}
                    styles={{
                        control: (base) => ({
                            ...base,
                            border: "2px solid lightGray",
                        }),
                        valueContainer: (base) => ({
                            ...base,
                            minHeight: "3rem",
                        }),
                    }}
                    value={
                        value
                    }
                />
            </div>

        </ElementContainer>
    );
});